import {type MutationTree} from 'vuex';

const mutations: MutationTree<ModuleCalendarState> = {
    setFindButton(state, payload)
    {
        state.showFindButton = payload;
    },
    setEventCourseEnabled(state, payload)
    {
        state.eventCourseEnabled = payload;
    },
    setNotifyClients(state, payload)
    {
        state.notifyClients = payload;
    },
};

export default mutations;